import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AppFeaturesState } from 'src/app/portal/app-feature.state';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class LoadingComponent {
  @Input() loading: boolean;
  @Input() message: string | undefined;

  constructor(public appFeaturesState: AppFeaturesState) {}
}
